import { useAppData } from '../../../contexts/appData';
import { Android } from '../../../utils/android';
import { FC, useEffect } from 'react';

export const ExposeForAndroid: FC = () => {
    const context = useAppData();

    useEffect(() => {
        (window as any).ANDROID_BRIDGE_updateFirebaseToken = (token: string) =>
            Android.handleNewFirebaseToken(token, context)
    }, [context]);

    return <></>
}